export default __webpack_public_path__ + "static/media/Teacher.6be66178.webp";